import React from 'react';
import { Plus, X } from 'lucide-react';

// Numbered, foolproof certifications editor. Stores/returns a newline-joined
// string (one certification per line) but shows each as its own numbered row.
export default function CertificationsField({ value, onChange }) {
  const rows = (value || '').split('\n');
  const list = rows.length ? rows : [''];
  const update = (arr) => onChange(arr.join('\n'));
  const setAt = (i, v) => { const a = [...list]; a[i] = v; update(a); };
  const addRow = () => update([...list, '']);
  const removeAt = (i) => { const a = list.filter((_, idx) => idx !== i); update(a.length ? a : ['']); };
  return (
    <div className="space-y-2" data-testid="certifications-field">
      {list.map((item, i) => (
        <div key={i} className="flex items-center gap-2.5">
          <span className="flex-shrink-0 w-7 h-7 rounded-full bg-cmic-100 text-cmic-700 text-sm font-bold flex items-center justify-center tabular-nums">{i + 1}</span>
          <input
            type="text"
            value={item}
            onChange={(e) => setAt(i, e.target.value)}
            data-testid={`certification-input-${i}`}
            placeholder="Ej: Intérprete Certificado ATA"
            className="flex-1 min-w-0 rounded-xl border border-gray-200 px-4 py-2.5 text-sm text-charcoal-800 focus:outline-none focus:ring-2 focus:ring-cmic-500/30 focus:border-cmic-500"
          />
          <button
            type="button"
            onClick={() => removeAt(i)}
            data-testid={`certification-remove-${i}`}
            title="Quitar"
            className="flex-shrink-0 p-2 rounded-lg text-charcoal-400 hover:bg-rose-50 hover:text-rose-600 transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      ))}
      <button
        type="button"
        onClick={addRow}
        data-testid="certification-add"
        className="inline-flex items-center gap-1.5 text-sm font-medium text-cmic-600 hover:text-cmic-700 hover:bg-cmic-50 rounded-lg px-2.5 py-1.5 transition-colors"
      >
        <Plus size={16} /> Agregar certificación
      </button>
    </div>
  );
}
